<div class="fs__map-popup">{{ text }}</div>
